const backdropGrayscale = {
    name: "backdrop-grayscale",
    path: "/backdrop-grayscale",
    title: "backdrop-grayscale",
    description: "Utilities for applying backdrop-grayscale filter effects to element's backdrop:",
    value: {
        'backdrop-filter': {
            'backdrop-grayscale': 'grayscale(100%)',
            'backdrop-grayscale-<number>': 'grayscale(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "backdrop-grayscale-50, backdrop-grayscale-100",
            "description": "to control an element's backdrop-grayscale:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-grayscale-0",
                        "text": "backdrop-grayscale-0",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-grayscale-25",
                        "text": "backdrop-grayscale-25",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-grayscale-50",
                        "text": "backdrop-grayscale-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg backdrop-grayscale",
                        "text": "backdrop-grayscale",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="backdrop-grayscale-0" src="/img/mountains.jpg" />
<img class="backdrop-grayscale-25" src="/img/mountains.jpg" />
<img class="backdrop-grayscale-50" src="/img/mountains.jpg" />
<img class="backdrop-grayscale" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default backdropGrayscale;